/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "bar-echart"
};
import BaseEchart from '@/base-ui/echart';
export default /*#__PURE__*/_defineComponent({
  __name: 'bar-echart-reverse',
  props: {
    lineData: {},
    xLabels: {},
    legendData: {},
    color: {},
    customTooltip: {
      type: Boolean,
      default: false
    },
    formatter: {}
  },
  setup: function setup(__props) {
    var props = __props;
    var options = computed(function () {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: props.legendData
        },
        grid: {
          left: 50,
          top: 30,
          bottom: 30,
          right: 20
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            // inside: true,
            color: '#999999',
            interval: 0,
            rotate: 30
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          z: 10
        },
        yAxis: {
          type: 'category',
          data: props.xLabels,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#999'
            }
          }
        },
        dataZoom: [{
          type: 'inside'
        }],
        series: [{
          name: props.legendData[0],
          type: 'bar',
          showBackground: true,
          itemStyle: {
            color: props.color
          },
          emphasis: {
            itemStyle: {
              color: props.color
            }
          },
          data: props.lineData
        }
        // {
        //   name: props.legendData[1],
        //   type: 'bar',
        //   showBackground: true,
        //   itemStyle: {
        //     color: '#5AC57F'
        //   },
        //   emphasis: {
        //     itemStyle: {
        //       color: '#5AC57F'
        //     }
        //   },
        //   data: props.lineData2
        // }
        ]
      };
      if (props.customTooltip) {
        option.tooltip.enterable = true;
        option.tooltip.formatter = props.formatter;
      }
      return option;
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(BaseEchart), {
        options: _unref(options),
        height: "160px"
      }, null, 8, ["options"])]);
    };
  }
});